export function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function readValue(source, path) {
    return path.reduce((value, key) => {
        if (Array.isArray(value) || isRecord(value)) {
            return value[key];
        }
        return undefined;
    }, source);
}

export function readString(source, path) {
    const value = readValue(source, path);
    return typeof value === 'string' ? value : '';
}

export function readNumber(source, path) {
    const value = readValue(source, path);
    return typeof value === 'number' && Number.isFinite(value) ? value : 0;
}

export function readStringList(source, path) {
    const value = readValue(source, path);
    return Array.isArray(value)
        ? value.filter((item) => typeof item === 'string')
        : [];
}

export function stringListToText(items, separator = '\n') {
    return (Array.isArray(items) ? items : []).join(separator);
}

export function textToStringList(value, mode = 'lines') {
    const separator = mode === 'paragraphs' ? /\n\s*\n/ : /\r?\n/;
    return String(value)
        .split(separator)
        .map((item) => item.trim())
        .filter(Boolean);
}

export function updateAtPath(source, path, nextValue) {
    const [key, ...rest] = path;
    if (key === undefined) {
        return nextValue;
    }

    const clone = Array.isArray(source)
        ? [...source]
        : isRecord(source)
            ? { ...source }
            : typeof key === 'number'
                ? []
                : {};

    const existing = Array.isArray(source) || isRecord(source) ? source[key] : undefined;
    clone[key] = updateAtPath(existing, rest, nextValue);
    return clone;
}

export function appendAtPath(source, path, item) {
    const current = readValue(source, path);
    const nextItems = Array.isArray(current) ? [...current, item] : [item];
    return updateAtPath(source, path, nextItems);
}

export function removeAtPath(source, path, index) {
    const current = readValue(source, path);
    if (!Array.isArray(current)) {
        return source;
    }
    return updateAtPath(
        source,
        path,
        current.filter((_, itemIndex) => itemIndex !== index)
    );
}

export function createFaqItem() {
    return {
        id: `faq-${Date.now()}`,
        question: 'Новый вопрос',
        answer: 'Ответ на вопрос',
    };
}

export function createReviewItem() {
    return {
        id: `review-${Date.now()}`,
        title: 'Новый отзыв',
        meta: 'Анонимный отзыв',
        product: 'Telegram Stars',
        text: 'Текст отзыва',
        badge: 'анонимно',
    };
}

export function createSeoHighlight() {
    return {
        title: 'Новый блок',
        body: 'Описание блока',
    };
}

export function createSeoStep() {
    return {
        title: 'Новый шаг',
        body: 'Описание шага',
    };
}

export function createSeoSection() {
    return {
        title: 'Новый раздел',
        paragraphs: ['Текст раздела'],
        bullets: [],
    };
}

export function createSeoFaqItem() {
    return {
        question: 'Новый вопрос',
        answer: 'Ответ на вопрос',
    };
}
